// Owner in P2: piece 11 "People screen and person page" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): the table at /people and the page at /people/$personId, each a
// lazy chunk. The paths carry a person id and filter codes only (never free text). The register is the owner's, so the
// rail entry is `ownerOnly`; the route and the API refuse a member on their own.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Users } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseFilters, parsePersonSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/people',
      validateSearch: (search: Record<string, unknown>) => parseFilters(search),
      component: lazyRouteComponent(() => import('./PeopleScreen.tsx')),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/people/$personId',
      validateSearch: (search: Record<string, unknown>) => parsePersonSearch(search),
      component: lazyRouteComponent(() => import('./PersonScreen.tsx')),
    }),
  ],
  nav: [{ to: '/people', label: 'nav.people', icon: Users, group: 'work', key: 'p', ownerOnly: true }],
}
